import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/layout/ErrorBoundary';
import { ToastContainer } from './components/layout/ToastContainer';
import './index.css';
import { queryClient } from './lib/query-client';
import { useAuthStore } from './stores/auth-store';

function RouteAwareErrorBoundary({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  return <ErrorBoundary key={`${location.pathname}${location.search}`}>{children}</ErrorBoundary>;
}

// Rehydrate auth state from localStorage before render
useAuthStore.getState().hydrate();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <RouteAwareErrorBoundary>
          <App />
          <ToastContainer />
        </RouteAwareErrorBoundary>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
